<template>
  <div class='block-main-content'>
    <div class='block-main-ajax block-main-ajax-live'>
      <p v-if='showDate'>{{dateTitle}}</p>
      <h2 class='block-main-title-small'>{{mainTitle}}</h2>
      <top-text-box-main-url v-if='showMainUrl'></top-text-box-main-url>
      <top-text-box-government-attendees v-if='showMeetingAttendees'></top-text-box-government-attendees>
      <div v-if='showMainText' v-html='mainText'></div>
      <p v-if='showHearingLingerText'>{{hearingLingerText}}</p>
      <top-text-box-link-list v-if='showLinkList'></top-text-box-link-list>
    </div>
    <top-text-box-bottom-buttons></top-text-box-bottom-buttons>
  </div>
</template>

<script>
import mixins from '../../mixins'
import TopTextBoxGovernmentAttendees from './TopTextBoxGovernmentAttendees'
import TopTextBoxMainUrl from './TopTextBoxMainUrl'
import TopTextBoxLinkList from './TopTextBoxLinkList'
import TopTextBoxBottomButtons from './TopTextBoxBottomButtons'

export default {
  mixins: [mixins],
  name: 'top-text-box',
  data () {
    return {
      dateTitle: this.liveHelper().currentDateTitle(this.$root.cmsData, this.$root.liveData),
      mainTitle: this.liveHelper().currentMainTitle(this.$root.cmsData, this.$root.liveData),
      mainText: this.liveHelper().mainText(this.$root.cmsData, this.$root.liveData),
      hearingLingerText: this.liveHelper().hearingLingerText(this.$root.cmsData, this.$root.liveData)
    }
  },
  computed: {
    showDate: function () {
      return this.dateTitle !== undefined
    },
    showMainText: function () {
      return this.mainText !== undefined
    },
    showMainUrl: function () {
      return this.liveHelper().shouldShowMainUrl(this.$root.cmsData, this.$root.liveData)
    },
    showMeetingAttendees: function () {
      return this.liveHelper().shouldShowMeetingAttendees(this.$root.cmsData, this.$root.liveData)
    },
    showHearingLingerText: function () {
      return this.hearingLingerText !== undefined
    },
    showLinkList: function () {
      return this.liveHelper().shouldShowLinkList(this.$root.cmsData, this.$root.liveData)
    }
  },
  components: {
    TopTextBoxGovernmentAttendees,
    TopTextBoxMainUrl,
    TopTextBoxLinkList,
    TopTextBoxBottomButtons
  }
}
</script>



// WEBPACK FOOTER //
// TopTextBox.vue?e641db1e